export default function() {}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/noop.js
// module id = ../../../../d3-shape/src/noop.js
// module chunks = 4